import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Check.es.js";
const o = e.forwardRef((c, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...c, weights: a }));
o.displayName = "CheckIcon";
const n = o;
export {
  n as Check,
  o as CheckIcon
};
